import { FC } from "react";
import SalesProductAnalyticsTabsDashboard from "../components/SalesProductAnalyticsTabsDashboard";

const SalesProductAnalyticsDashboard: FC = () => {
  return <SalesProductAnalyticsTabsDashboard />;
};

export default SalesProductAnalyticsDashboard;
